import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from '../../context/AuthContext';
import { authConfig } from '../../config/auth';

const AuthProviders = ({ children }) => {
  const googleClientId = authConfig.google.clientId;

  return (
    <AuthProvider>
      <GoogleOAuthProvider clientId={googleClientId}>
        {children}
      </GoogleOAuthProvider>
    </AuthProvider>
  );
};

export default AuthProviders;